
import axios from "axios";

const urlUsers = process.env.REACT_APP_GLOBAL_USERS_API_URL;
const apiKey = process.env.REACT_APP_GLOBAL_USERS_XAPIKEY;


export const postFraudUsers = async (data: any, token: string) => {
    const urlRequest = `${urlUsers}fraud_users`;
    const headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'x-api-key': apiKey
    }
    const res = await axios.post(urlRequest, data, { headers: headers});
    return res.data || [];
};

export const getAllFraudUsers = async ({ token }) => {
    const url = `${urlUsers}fraud_users/list?country=MX`;
    const headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'x-api-key': apiKey
    }
    const res = await axios.get(url, { headers: headers });
    return res?.data || [];
};


